import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cn } from "@/lib/utils";
import { bgColorMapping, isDarkColor } from "@/lib/colors";
import { BackgroundLayers } from "./BackgroundLayers";
import type { SectionBackgroundProps } from "./SectionBackground.props";

/**
 * SectionBackground renders background layers (color, image, video, pattern)
 * with appropriate theme class application.
 *
 * Can be used standalone or composed with SectionContent for full section layout.
 */
export const SectionBackground = t0 => {
  const $ = _c(22);
  const {
    as: t1,
    "aria-label": ariaLabel,
    backgroundColor: t2,
    backgroundImage,
    backgroundVideo,
    backgroundPattern,
    patternOpacity,
    isDark: isDarkProp,
    masked: t3,
    priority: t4,
    className,
    children
  } = t0;
  const Component = t1 === undefined ? "section" : t1;
  const backgroundColor = t2 === undefined ? "white" : t2;
  const masked = t3 === undefined ? true : t3;
  const priority = t4 === undefined ? false : t4;
  let t5;
  if ($[0] !== backgroundColor || $[1] !== isDarkProp) {
    t5 = isDarkProp ?? isDarkColor(backgroundColor);
    $[0] = backgroundColor;
    $[1] = isDarkProp;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const isDark = t5;
  const bgClass = bgColorMapping[backgroundColor] || "section-aq-white";
  let t6;
  if ($[3] !== bgClass || $[4] !== className) {
    t6 = cn("relative overflow-hidden", bgClass, className);
    $[3] = bgClass;
    $[4] = className;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = Component === "section" && ariaLabel ? "region" : undefined;
  let t8;
  if ($[6] !== backgroundColor || $[7] !== backgroundImage || $[8] !== backgroundPattern || $[9] !== backgroundVideo || $[10] !== isDark || $[11] !== masked || $[12] !== patternOpacity || $[13] !== priority) {
    t8 = <BackgroundLayers backgroundColor={backgroundColor} backgroundImage={backgroundImage} backgroundVideo={backgroundVideo} backgroundPattern={backgroundPattern} patternOpacity={patternOpacity} isDark={isDark} masked={masked} priority={priority} />;
    $[6] = backgroundColor;
    $[7] = backgroundImage;
    $[8] = backgroundPattern;
    $[9] = backgroundVideo;
    $[10] = isDark;
    $[11] = masked;
    $[12] = patternOpacity;
    $[13] = priority;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== Component || $[16] !== ariaLabel || $[17] !== children || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <Component className={t6} aria-label={ariaLabel} role={t7}>{t8}{children}</Component>;
    $[15] = Component;
    $[16] = ariaLabel;
    $[17] = children;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};